import { Link, graphql, useStaticQuery } from "gatsby"
import React, { useState, useEffect, Fragment } from "react"
import { Button, Popover } from "antd"
import {
  NavBarContainer,
  NavLinkContainer,
  NavLink
} from './styles';
import PopoverContent from './PopoverContent';

const NavigationMenu = props => {

  const [url, setUrl] = useState('');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setUrl(window.location.href);
    }
  }, []);

  const isPartiallyActive = () => {
    if (url) {
      return url.indexOf('/services/') >= 0 ? { className: "activeLink" } : null;
    }
  }
  //popover

  const [popoverVisible, setPopoverVisible] = useState(false);

  const data = useStaticQuery(graphql`
    query {
      file(relativePath: {eq: "home/footer.md"}) {
        childMarkdownRemark {
          frontmatter {
            sitemapList {
              id
              title
              link
              sitemap {
                id
                link
                title
              }
            }
          }
        }
      }

      
    serviceData: allMarkdownRemark(filter: {fileAbsolutePath: {regex: "/(services)\\/.*\\\\.md$/"}}, sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            title
            navTitle
            navIndex
            excerpt
            author
            author_image {
              childImageSharp {
                fluid {
                  src
                }
              }
              extension
              publicURL
            }
            date(formatString: "MMMM DD, YYYY")
          }
        }
      }
    }
    }
  `);

  const popoverLink = () => {
    setPopoverVisible(false);
  };

  const onVisibleChange = visible => {
    setPopoverVisible(visible);
  };

  return (
    <Fragment>
      <NavBarContainer >
        <NavLinkContainer>
          <NavLink key="about">
            <Link to="/about/" activeClassName="activeLink" onClick={props.onClick}>About</Link>
          </NavLink>
          <NavLink key="services">
            <Popover
              overlayClassName="navPopover"
              content={<PopoverContent content={data.file.childMarkdownRemark.frontmatter} serviceData={data?.serviceData?.edges} onClick={popoverLink} />}
              visible={popoverVisible}
              onVisibleChange={onVisibleChange}
              placement="bottom"
            >
              <Link
                to="/services/academic_editing"
                getProps={isPartiallyActive}
                activeClassName="activeLink"
                onClick={props.onClick}
                onMouseOver={() => setPopoverVisible(true)}
                onFocus={() => setPopoverVisible(true)}
                id="mob-service-popover"
              >
                Services
              </Link>
            </Popover>
            <Link
              to="/services/academic_editing"
              getProps={isPartiallyActive}
              activeClassName="activeLink"
              onClick={props.onClick}
              id="mob-services-link"
            >
              Services
            </Link>
          </NavLink>
          <NavLink key="blog">
            <Link to="/blog" partiallyActive={true} activeClassName="activeLink" onClick={props.onClick}>Resources</Link>
          </NavLink>
          <NavLink key="contact">
            <Link to="/contact/" activeClassName="activeLink" onClick={props.onClick} role="presentation">Contact</Link>
          </NavLink>
          <NavLink key="contact">
            <Link to="/pricing/#pricing" activeClassName="activeLink" onClick={props.onClick} role="presentation">Pricing</Link>
          </NavLink>
          <NavLink key="blog">
            <a href="https://blog.contentconcepts.in/" target="_blank" rel="noopener" activeClassName="activeLink" onClick={props.onClick}>Blog</a>
          </NavLink>
        </NavLinkContainer>
        <a href="https://creatorapp.zohopublic.com/contentconcepts/cc-doc-manager/form-perma/CC_Quote_Form_INR/gsOtq9Spazxg3vv3msj1zDBTqMhK2gqNHtRHzMA4rem3CnZCdQm9XzmAhJO9AUJNwxW4mupdZuMhqkMCRgU6HMQw5wjgw7tH4R8x" target="_blank" rel="noopener">
<Button type="primary">Submit Document</Button></a>
      </NavBarContainer>
    </Fragment>
  )
}

export default NavigationMenu
